import React, { useState } from "react";
import { FaXmark } from "react-icons/fa6";
import { HiOutlineMenuAlt3 } from "react-icons/hi";

const NavItem = ({ link, label, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    const targetElement = document.querySelector(link);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
    onClick();
  };
  return (
    <a
      className=" hover:text-secondary duration-700 delay-100 transition-all font-normal text-sm md:text-lg"
      href={link}
      onClick={handleClick}
    >
      {label}
    </a>
  );
};

export default function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);

  const navItems = [
    {
      link: "#about",
      label: "About Me",
    },
    {
      link: "#skills-certifications",
      label: "Skills & Certifications",
    },
    {
      link: "#projects",
      label: "Projects",
    },
  ];
  return (
    <div className="px-10 pt-5 pb-4 justify-between flex md:px-20 md:pt-10 md:pb-8  md:grid-cols-3 sticky top-0 md:relative bg-gray-950">
      {/* logo */}
      <div className="col-span-1 py-2 font-semibold text-secondary text-xl">
        JSB
      </div>
      {/* navItems */}
      <div className="col-span-2 grid-cols-3 py-2 space-x-10 hidden md:block">
        {navItems.map((item, index) => (
          <NavItem key={index} link={item.link} label={item.label} onClick={() => console.log("Scrolling to section " + item.label)} />
        ))}
      </div>
      {/* contact me button */}
      <div className="col-span-1 ">
        <a
          href="mailto:jbisht268@gmail.com"
          className=" py-2 px-4 rounded-md bg-white text-black hover:bg-secondary hover:text-white font-medium duration-700 delay-100 transition-all hidden md:block"
        >
          Contact Me
        </a>
      </div>

      {/* sidebar toggle */}
      <div className="block md:hidden content-center">
        <HiOutlineMenuAlt3
          className="text-2xl text-white active:text-secondary"
          onClick={() => setToggleMenu(!toggleMenu)}
        />
      </div>

      {/* sidebar */}
      <div
        className={`duration-500 pt-5 md:hidden fixed w-7/12 h-full bg-gray-900 text-xl font-semibold text-white gap-2 top-0 ${
          toggleMenu ? `right-[0]` : `right-[-100%]`
        } `}
      >
        <div className="block md:hidden absolute right-10 ">
          <FaXmark
            className="text-2xl text-white active:text-secondary"
            onClick={() => setToggleMenu(!toggleMenu)}
          />
        </div>
        <ul className="my-10 py-5">
          {
            navItems.map((item, index) => (
              <li key={index} className="py-2 pl-5">
                <NavItem link={item.link} label={item.label} onClick={()=>setToggleMenu(false)} />
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
}
